import React from 'react';

import PlaidEndpoint from '../endpoint/plaid-endpoint'
import PlaidProductTypesContainer from './product-types-container/plaid-product-types-container'
import {
  transactionsCategories,
  authCategories,
  identityCategories,
  balanceCategories,
  investmentsCategories,
  investmentsTransactionsCategories,
  liabilitiesCategories,
  paymentCategories,
  assetsCategories,
  incomePaystubsCategories,
  transferCategories,
  transferAuthorizationCategories,
  signalCategories,
  statementsCategories,
  transformAuthData,
  transformTransactionsData,
  transformBalanceData,
  transformInvestmentsData,
  transformInvestmentTransactionsData,
  transformLiabilitiesData,
  transformIdentityData,
  transformPaymentData,
  transformAssetsData,
  transformTransferData,
  transformTransferAuthorizationData,
  transformIncomePaystubsData,
  transformSignalData,
  transformStatementsData
} from '../utils/plaid-data-utilities'

const PlaidProducts = ({ products = [] }) => {
  return (
    <div className='plaid-products'>
      <PlaidProductTypesContainer productType='Products'>
        {products.includes('payment_initiation') && (
          <PlaidEndpoint
            endpoint='payment'
            name='Payment'
            categories={paymentCategories}
            schema='/payment/get/'
            description='Retrieve information about your latest payment.'
            transformData={transformPaymentData}
          />
        )}
        {products.includes('auth') && (
          <PlaidEndpoint
            endpoint='auth'
            name='Auth'
            categories={authCategories}
            schema='/auth/get/'
            description='Retrieve account and routing numbers for checking and savings accounts.'
            transformData={transformAuthData}
          />
        )}
        {products.includes('transactions') && (
          <PlaidEndpoint
            endpoint='transactions'
            name='Transactions'
            categories={transactionsCategories}
            schema='/transactions/sync/'
            description='Retrieve transactions or incremental updates for credit and depository accounts.'
            transformData={transformTransactionsData}
          />
        )}
        {products.includes('identity') && (
          <PlaidEndpoint
            endpoint='identity'
            name='Identity'
            categories={identityCategories}
            schema='/identity/get/'
            description='Retrieve Identity information on file with the bank. Reduce
          fraud by comparing user-submitted data to validate identity.'
            transformData={transformIdentityData}
          />
        )}
        {products.includes('assets') && (
          <PlaidEndpoint
            endpoint='assets'
            name='Assets'
            categories={assetsCategories}
            schema='/asset_report/get/'
            description='Create and retrieve assets information an asset report'
            transformData={transformAssetsData}
          />
        )}
        {!products.includes('payment_initiation') && (
          <PlaidEndpoint
            endpoint='balance'
            name='Balance'
            categories={balanceCategories}
            schema='/accounts/balance/get/'
            description='Check balances in real time to prevent non-sufficient funds
      fees.'
            transformData={transformBalanceData}
          />
        )}
        {products.includes('investments') && (
          <>
            <PlaidEndpoint
              endpoint='holdings'
              name='Investments'
              categories={investmentsCategories}
              schema='/investments/holdings/get/'
              description='Retrieve investment holdings on file with the bank,
        brokerage, or investment institution. Analyze over-exposure
        to market segments.'
              transformData={transformInvestmentsData}
            />
            <PlaidEndpoint
              endpoint='investments_transactions'
              name='Investments Transactions'
              categories={investmentsTransactionsCategories}
              schema='/investments/transactions/get'
              description='Retrieve investment transactions on file with the bank,
        brokerage, or investments institution.'
              transformData={transformInvestmentTransactionsData}
            />
            <PlaidEndpoint
              endpoint='liabilities'
              name='Liabilities'
              categories={liabilitiesCategories}
              schema='/liabilities/get'
              description='Retrieve liabilities and various details about an Item with loan or credit accounts.'
              transformData={transformLiabilitiesData}
            />
          </>
        )}
        {products.includes('transfer') && (
          <>
            <PlaidEndpoint
              endpoint='transfer_authorize'
              name='Transfer'
              categories={transferAuthorizationCategories}
              schema='/transfer/authorization/create'
              description='Authorize a new 1-dollar ACH transfer payment from the linked account'
              transformData={transformTransferAuthorizationData}
            />
            <PlaidEndpoint
              endpoint='transfer_create'
              name='Transfer'
              categories={transferCategories}
              schema='/transfer/create/'
              description='(After calling /transfer/authorization/create) Execute an authorized 1-dollar ACH transfer payment from the first linked account'
              transformData={transformTransferData}
            />
          </>
        )}
        {products.includes('signal') && (
          <>
            <PlaidEndpoint
              endpoint='signal_evaluate'
              name='Signal'
              categories={signalCategories}
              schema='/signal/evaluate'
              description='Evaluate the return risk of a proposed $100 debit from the first linked account (in Sandbox, results are randomly generated)'
              transformData={transformSignalData}
            />
          </>
        )}
        {products.includes('statements') && (
          <>
            <PlaidEndpoint
              endpoint='statements'
              name='Statements'
              categories={statementsCategories}
              schema='/statements/list and /statements/download'
              description='List out and download the most recent statement'
              transformData={transformStatementsData}
            />
          </>
        )}

        {products.includes('income_verification') && (
          <PlaidEndpoint
            endpoint='/income/verification/paystubs'
            name='Income Paystubs'
            categories={incomePaystubsCategories}
            schema='/income/verification/paystubs'
            description='(Deprecated) Retrieve information from the paystubs used for income verification'
            transformData={transformIncomePaystubsData}
          />
        )}
      </PlaidProductTypesContainer>
    </div>
  )
}

PlaidProducts.displayName = 'Products'

export default PlaidProducts
